export const GET_ALL_CASHIERS = "GET_ALL_CASHIERS"
export const GET_ALL_CASHIERS_RESPONSE_SUCCESS =
  "GET_ALL_CASHIERS_RESPONSE_SUCCESS"
export const CREATE_CASHIER = "CREATE_CASHIER"
export const UPDATE_CASHIER = "UPDATE_CASHIER"
export const DELETE_CASHIER = "DELETE_CASHIER"
